import en from './en';
import es from './es';
import fr from './fr';
import it from './it';

export const englishMessages = en;
export const spanishMessages = es;
export const frenchMessages = fr;
export const italianMessages = it;

export * from './i18nProvider';
export * from './LocaleSwitcherMenu';
export * from './supportedLocales';
